export default __webpack_public_path__ + "static/media/cnp20_1.830a5c39.png";